import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, finalize,  } from 'rxjs/operators';
import { AuthUserService } from '../services/auth-user.service';
import { AlertService } from '../services/alert.service';
import { MESSAGES } from 'app/common/constants';
import Swal from "sweetalert2";
import { SKIP_UNAUTHORIZED_HANDLING_HEADER } from './http-context.tokens';
import { POST_LOGIN_REDIRECT_STORAGE_KEY } from '../auth/post-login-redirect';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private requestCount = 0;

  constructor(
      private authUserService: AuthUserService,
      private alertService: AlertService,
      private router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authUserService.AuthToken;
    if (token) {
      req = req.clone({ setHeaders: { authorization: `Bearer ${token}` } });
    }
    const shouldSkipUnauthorizedHandling = req.headers.get(SKIP_UNAUTHORIZED_HANDLING_HEADER) === 'true';
    this.startRequest();

    return next.handle(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            if (event.body?.statusCode === 401 || event.status === 401) {
              if (!shouldSkipUnauthorizedHandling) {
                this.handleUnauthorized();
              }
            }
          }
        }),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 401 || err.error?.statusCode === 401) {
            if (!shouldSkipUnauthorizedHandling) {
              this.alertService.errorToast(MESSAGES.ERRORS.UnauthorizedUser);
              this.handleUnauthorized();
            }
          }
          return throwError(err);
        }),
        finalize(() => this.endRequest())
    );
  }

  private handleUnauthorized(): void {
    Swal.close();
    try {
      const url = this.router.url;
      if (url) {
        sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, url);
      }
    } catch {
      // ignore
    }
    this.authUserService.clearAuthData();
  }

  private startRequest(): void {
    this.requestCount++;
  }

  private endRequest(): void {
    this.requestCount--;
  }
}
